export default __webpack_public_path__ + "static/media/hospitality2.baffa2f9.webp";